'use client';

import { c as _c } from "react/compiler-runtime";
import { signIn } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { defaultSearchParams } from '@/misc/utils';
import { KeystoneSigninScreen } from './KeystoneSigninScreen';
import { SelectOptions } from './types';
type Props = {
  enabledAzure: boolean;
  enabledLDAP: boolean;
  enabledKUA: boolean;
  requestEndpoint: string;
  requestDataOptions: SelectOptions;
  azureAdProviderId: string;
  requestAccessEnabled: boolean;
};
export const SignIn = t0 => {
  const $ = _c(25);
  const {
    enabledAzure,
    enabledLDAP,
    enabledKUA,
    requestEndpoint,
    requestDataOptions,
    azureAdProviderId,
    requestAccessEnabled
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new URLSearchParams(defaultSearchParams).toString();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const searchParameters = t1;
  let t2;
  if ($[1] !== azureAdProviderId) {
    t2 = async () => {
      signIn(azureAdProviderId, {
        callbackUrl: `/projects?${searchParameters}`
      });
    };
    $[1] = azureAdProviderId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const callbackAzure = t2;
  let t3;
  if ($[3] !== router) {
    t3 = async (email, password) => {
      const login = await signIn("credentials", {
        email,
        password,
        provider: "kua",
        redirect: false
      });
      if (login?.ok) {
        router.push(`/projects?${searchParameters}`);
        return true;
      }
      if (!login?.ok) {
        return false;
      }
      return false;
    };
    $[3] = router;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const callbackKua = t3;
  let t4;
  if ($[5] !== router) {
    t4 = async (email_0, password_0) => {
      const login_0 = await signIn("credentials", {
        email: email_0,
        password: password_0,
        provider: "ldap",
        redirect: false
      });
      if (login_0?.ok) {
        router.push(`/projects?${searchParameters}`);
        return true;
      }
      if (!login_0?.ok) {
        return false;
      }
      return false;
    };
    $[5] = router;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const callbackLdap = t4;
  let t5;
  if ($[7] !== callbackAzure || $[8] !== enabledAzure) {
    t5 = {
      enabled: enabledAzure,
      callback: callbackAzure
    };
    $[7] = callbackAzure;
    $[8] = enabledAzure;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== callbackLdap || $[11] !== enabledLDAP) {
    t6 = {
      enabled: enabledLDAP,
      callback: callbackLdap
    };
    $[10] = callbackLdap;
    $[11] = enabledLDAP;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== callbackKua || $[14] !== enabledKUA) {
    t7 = {
      enabled: enabledKUA,
      callback: callbackKua
    };
    $[13] = callbackKua;
    $[14] = enabledKUA;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = {
      azureAD: t5,
      credentialsLDAP: t6,
      credentialsKUA: t7
    };
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const signInOptions = t8;
  let t9;
  if ($[20] !== requestAccessEnabled || $[21] !== requestDataOptions || $[22] !== requestEndpoint || $[23] !== signInOptions) {
    t9 = <KeystoneSigninScreen signInOptions={signInOptions} options={requestDataOptions} requestAccessUrl={requestEndpoint} requestAccessEnabled={requestAccessEnabled} />;
    $[20] = requestAccessEnabled;
    $[21] = requestDataOptions;
    $[22] = requestEndpoint;
    $[23] = signInOptions;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};